import type { Rule } from "./types";
import { systemRules } from "./system";
import { loadRuleOrder, loadSystemRuleOverrides, loadUserRules } from "./storage";

export async function loadAllRules(): Promise<Rule[]> {
  const [overrides, userRules, order] = await Promise.all([
    loadSystemRuleOverrides(),
    loadUserRules(),
    loadRuleOrder(),
  ]);

  const systemWithOverrides: Rule[] = systemRules.map((r) => {
    const ov = overrides[r.id];
    if (!ov) return r;
    return ov.enabled !== undefined ? { ...r, enabled: ov.enabled } : r;
  });

  const all = [...systemWithOverrides, ...userRules];
  if (order.length === 0) return all;

  const byId = new Map(all.map((r) => [r.id, r]));
  const ordered: Rule[] = [];
  for (const id of order) {
    const r = byId.get(id);
    if (r) {
      ordered.push(r);
      byId.delete(id);
    }
  }
  // Append any rules not in saved order (e.g., new system rules after upgrade)
  ordered.push(...byId.values());
  return ordered;
}
